import DOTDMenu from "./modules/menu.js";
import SiteImprove from "../../thirdparty/siteimprove/siteimprove.js";
import ImageError4i from '../../common/imageerror25.js';

const headerWrapper = document.getElementById("headerLinks");
let accountPromise = null;

async function init(){
	if(headerWrapper) headerWrapper.addEventListener("click", events);
    if(document.getElementById("menuWrapper")) DOTDMenu.init();
    ImageError4i.init();
    SiteImprove.init();
    window.addEventListener('appinstalled', adobeLogAppInstall);

    if(document.getElementById("needsRecaptcha")){
        const { default: recaptcha } = await import('../../thirdparty/recaptcha/recaptchascript.js');
        recaptcha.init();
    }

    if (!('inert' in HTMLElement.prototype) || !('loading' in HTMLImageElement.prototype)) {
        const { default: banner } = await import('../../common/upgradebrowser.js');
        banner.init();
    }

    if (document.getElementById("noibuOn")?.value == "true") {
        const {default: noibu } = await import('../../thirdparty/noibu/noibu.js');
        noibu.init();
    }
}

async function events(e){
    const target = e.target;
    if(target.id === "hdrAccountBtn"){
        e.preventDefault();
        const account = await loadAccountDropdown();
        if(account) account.toggle(e);
    }
}

function adobeLogAppInstall(){
    var s = typeof s_gi === 'function' ? s_gi(s_account) : '';
    if (s) {
        s.events = 'event11';
        s.t();
    }
}

async function loadAccountDropdown() {
    if(accountPromise){ return accountPromise.default; }
    try {
        accountPromise = await import('../../main/layouts/modules/accountdropdown.js');
        return accountPromise.default; // Return the default export
    } catch (error) {
        console.error("Error in loadAccountDropdown. Failed to load account dropdown module:", error);
        accountPromise = null; // Reset to allow retry on failure
        return null;
    }
}

await init();